import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const privacyContent = `
Política de Privacidad

Última actualización: Enero 2026

En VidaClave, nos comprometemos a proteger tu privacidad. Esta política describe cómo recopilamos, usamos y protegemos tu información personal.

1. Información que recopilamos
Recopilamos información que nos proporcionás voluntariamente al realizar una compra, como tu nombre, dirección de correo electrónico y datos de pago.

2. Uso de la información
Utilizamos tu información para:
• Procesar tu compra y entregarte el ebook y los bonus.
• Enviarte comunicaciones relacionadas con tu compra.
• Mejorar nuestros productos y servicios.

3. Protección de datos
Implementamos medidas de seguridad para proteger tu información personal contra acceso no autorizado, alteración o destrucción.

4. Compartir información
No vendemos, intercambiamos ni transferimos tu información personal a terceros, excepto cuando sea necesario para procesar tu compra (por ejemplo, procesadores de pago).

5. Cookies
Nuestro sitio puede utilizar cookies para mejorar tu experiencia de navegación. Podés configurar tu navegador para rechazar cookies.

6. Tus derechos
Tenés derecho a acceder, rectificar o eliminar tu información personal. Para ejercer estos derechos, contactanos a través de nuestros canales oficiales.

7. Cambios en esta política
Nos reservamos el derecho de actualizar esta política en cualquier momento. Te notificaremos sobre cambios significativos.
`.trim();
const termsContent = `
Términos y Condiciones

Última actualización: Enero 2026

Al adquirir el ebook "30 Días Sin Pantallas", aceptás los siguientes términos y condiciones.

1. Producto digital
El ebook "30 Días Sin Pantallas" es un producto digital descargable. Una vez realizada la compra, recibirás acceso inmediato al material.

2. Uso personal
El contenido del ebook es para uso personal y familiar. Queda prohibida su reproducción, distribución o reventa sin autorización expresa.

3. Propiedad intelectual
Todo el contenido del ebook, incluyendo textos, diseños y materiales complementarios, está protegido por derechos de autor. Todos los derechos reservados.

4. Política de reembolso
Ofrecemos una garantía de satisfacción de 7 días. Si no estás conforme con el producto, podés solicitar un reembolso completo dentro de los 7 días posteriores a la compra.

5. Limitación de responsabilidad
El contenido del ebook es informativo y educativo. No reemplaza el asesoramiento profesional de un psicólogo o especialista en salud mental infantil. Los resultados pueden variar según cada familia.

6. Modificaciones
Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán efectivos desde su publicación.

7. Legislación aplicable
Estos términos se rigen por las leyes de la República Argentina.
`.trim();
function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}) {
  return <AnimatePresence data-id="element-33">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-34">
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/50" data-id="element-35" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-warm-white rounded-xl shadow-2xl max-w-lg w-full max-h-[80vh] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-36">
            {/* Header */}
            <div className="flex items-center justify-between p-5 border-b border-beige" data-id="element-37">
              <h3 className="font-playfair text-lg font-semibold text-dark-text" data-id="element-38">
                {title}
              </h3>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-beige transition-colors" aria-label="Cerrar" data-id="element-39">
                <X className="w-5 h-5 text-medium-text" data-id="element-40" />
              </button>
            </div>

            {/* Content */}
            <div className="p-5 overflow-y-auto flex-1" data-id="element-41">
              <div className="font-lato text-sm text-medium-text leading-relaxed whitespace-pre-line" data-id="element-42">
                {content}
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full bg-beige py-8 px-6" data-id="element-43">
        <div className="max-w-2xl mx-auto text-center" data-id="element-44">
          <div className="flex items-center justify-center gap-6" data-id="element-45">
            <button onClick={() => setShowPrivacy(true)} className="font-lato text-sm text-medium-text hover:text-dark-text underline underline-offset-2 transition-colors" data-id="element-46">
              Política de Privacidad
            </button>
            <span className="text-medium-text/40" data-id="element-47">|</span>
            <button onClick={() => setShowTerms(true)} className="font-lato text-sm text-medium-text hover:text-dark-text underline underline-offset-2 transition-colors" data-id="element-48">
              Términos y Condiciones
            </button>
          </div>
          <p className="font-lato text-xs text-medium-text/60 mt-4" data-id="element-49">
            © 2026 VidaClave. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" content={privacyContent} data-id="element-50" />
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" content={termsContent} data-id="element-51" />
    </>;
}